import { c as _c } from "react-compiler-runtime";
import { useEffect } from "react";
export default function useOnEscape(callback) {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] !== callback) {
    t0 = () => {
      if (typeof window === "undefined") {
        return;
      }
      const handleKeyUp = event => {
        if (event.key === "Escape") {
          callback();
        }
      };
      document.addEventListener("keyup", handleKeyUp);
      return () => document.removeEventListener("keyup", handleKeyUp);
    };
    t1 = [callback];
    $[0] = callback;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {};
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}